import placeholderLogo from '../assets/icon/check.png';

const placeholderLogos = Array.from({ length: 6 }, (_, index) => index + 1);

export default function LogosMarquee() {
    return (
        <div className='py-10'>
            <h2 className="text-white text-3xl font-bold text-center mb-8">Collaboriamo con</h2>

            <div className="relative w-full overflow-hidden">
                <div className="flex w-max gap-16 animate-marquee">
                    {/* LOGOS ANIMATON */}
                    {[...placeholderLogos, ...placeholderLogos].map((logo, index) => (
                        <div
                            key={index}
                            className="flex items-center justify-center w-32 h-16 shrink-0"
                        >
                            <img src={placeholderLogo} alt="logo partner" className="max-w-full max-h-full object-contain" />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
